import { AfterViewInit, Component, forwardRef, Input, ViewChild } from '@angular/core'
import { MatListOption, MatSelectionList } from '@angular/material/list'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'lin-checkbox-list',
  template: `
    <mat-selection-list [disabled]="isDisabled" (selectionChange)="onSelectionChange($event)">
      <ng-content></ng-content>
    </mat-selection-list>
  `,
  styleUrls: ['checkbox-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxListComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CheckboxListComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild(MatSelectionList, { static: true }) matSelectionList: MatSelectionList

  private value: any[] = []
  isDisabled = false
  private onChange: (value: any[]) => void = () => {}
  private onTouched: () => void = () => {}

  ngAfterViewInit() {
    // Ensure initial value is set
    if (this.value) {
      this.matSelectionList.selectedOptions.select(...this.matSelectionList.options.filter((option) => this.value.includes(option.value)))
    }
  }

  writeValue(v: any[]): void {
    this.value = v || []
    if (this.matSelectionList) {
      this.matSelectionList.selectedOptions.clear()
      this.matSelectionList.options.forEach((option) => {
        if (this.value.includes(option.value)) {
          option.selected = true
        }
      })
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled
  }

  onSelectionChange(event: any) {
    const selectedValues = event.source.selectedOptions.selected.map((option: MatListOption) => option.value)
    this.value = selectedValues
    this.onChange(selectedValues)
    this.onTouched()
  }
}

@Component({
  selector: 'lin-form-checkbox-option',
  template: `
    <mat-list-option [value]="value" [disabled]="disabled" checkboxPosition="before"><ng-content></ng-content></mat-list-option>
  `,
  styles: [
    `
      /* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */
      :host ::ng-deep .mat-list-text {
        font-size: 1.4rem;
      }

      /* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */
      .mat-mdc-list-item.mat-list-option {
        height: 30px;
      }

      /* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */
      .mat-list-item-disabled {
        background-color: initial;
        color: #b0b0b0;
      }
    `,
  ],
  standalone: false,
})
export class CheckboxOptionComponent {
  @Input() value: any
  @Input() disabled: boolean
}
